import React from 'react'
import { useSelector } from 'react-redux'
import { Skeleton, Toast, Typography } from '@chilecompra/react-kit/components'
import { REACT_APP_BASE_URL } from '../../config/settings/environment'
import ProtectByProfile from '../../components/Security/ProtectByProfile'
import { Link, Title } from './NoAccreditationSection.styles'

/**
 * The NoAccreditation's container.
 */
const NoAccreditation = () => {
  const { contractStatus, loading } = useSelector(state => state.basicSellerInformation)

  return (
    <>
      <Title>Documentos del proveedor</Title>

      <Typography fontSize="13px" variant="body2">
        Documentación cargada por el proveedor en la plataforma durante los <strong>últimos 12 meses.</strong>
      </Typography>

      {loading && (
        <>
          <Skeleton height="40px" variant="rect" width="100%" />
          <Skeleton height="40px" margin="10px 0 0" variant="rect" width="100%" />
          <Skeleton height="40px" margin="10px 0 0" variant="rect" width="100%" />
        </>
      )}

      {contractStatus !== 1 && !loading && (
        <Typography fontSize="13px" variant="subtitle">
          Esta empresa proveedora no ha realizado el pago de acreditación en el Registro de Proveedores, por lo que no
          podemos disponibilizar su documentación.
        </Typography>
      )}

      {contractStatus === 1 && !loading && (
        <ProtectByProfile rule={userType => userType === 'Proveedor'}>
          <Toast border disableIcon margin="24px 0 0" severity="warning">
            Toda la documentación puede ser cargada en la opción Administración / Mi Empresa ubicada en el menú de tu
            escritorio. Cuando los documentos hayan sido revisados y se encuentren en estado vigente, podrás
            visualizarlos en tu ficha.
            <br />
            <br />
            <Link href={`${REACT_APP_BASE_URL}/mi-empresa/documentos`}>Subir documentación</Link>
          </Toast>
        </ProtectByProfile>
      )}
    </>
  )
}

export default NoAccreditation
